
export default function ComingSoon(){
    return(
        <>
            <h1>Coming Soon</h1>
        </>
    )
}